import { render, staticRenderFns } from "./formWraper.vue?vue&type=template&id=82cab00a&"
import script from "./formWraper.vue?vue&type=script&lang=js&"
export * from "./formWraper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports